export default () => (
    <h1>Page not found</h1>
)